import { render, staticRenderFns } from "./editableIndex.vue?vue&type=template&id=0067e7a9&scoped=true&"
import script from "./editableIndex.vue?vue&type=script&lang=js&"
export * from "./editableIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067e7a9",
  null
  
)

export default component.exports